'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var classNames = require('classnames/bind');
var Row_module = require('./Row.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Row_module["default"]);
var Row = function (_a) {
    var _b = _a.align, align = _b === void 0 ? 'top' : _b, children = _a.children, className = _a.className, _c = _a.gutter, gutter = _c === void 0 ? 0 : _c, _d = _a.justify, justify = _d === void 0 ? 'start' : _d, _e = _a.wrap, wrap = _e === void 0 ? true : _e;
    var _f = Array.isArray(gutter) ? gutter : [gutter], _g = _f[0], colGap = _g === void 0 ? 0 : _g, _h = _f[1], rowGap = _h === void 0 ? 0 : _h;
    var rowClasses = cx(Row_module["default"].row, Row_module["default"][align], Row_module["default"]["colGap-".concat(colGap)], Row_module["default"]["rowGap-".concat(rowGap)], Row_module["default"][justify], !wrap && Row_module["default"].nowrap, className);
    return jsxRuntime.jsx("div", _tslib.__assign({ className: rowClasses }, { children: children }));
};

exports["default"] = Row;
//# sourceMappingURL=Row.js.map
